<template lang="html">
  <div class="succeed">
    <header></header>
    <main class="content">
      <img
        src="../../assets/image/apply_success.png"
        alt=""
        class="succeedImg"
      />
      <p class="txt1">恭喜尾号</p>
      <!-- 手机号后四位 -->
      <p class="txt2">{{phone.substr(-4)}}</p>
      <p class="txt3">报名签到成功</p>
      <p class="txt4">打开电巢APP，完善信息</p>
      <div class="openApp">
        打开
        <WxOpenTag ref="wxopentag"/>
      </div>
    </main>
  </div>
</template>

<script>
import utils from '@/utils/utils.js';
import WxOpenTag from '@/components/WxOpenTag'
export default {
  components: {
    WxOpenTag,
  },
  data() {
    return {
      succeed: [],
    };
  },
  created() {
    this.phone = this.$route.query.phone
  },
  mounted() {
    // 注册打开app组件
    if(utils.browserChecker.isWx()){
      this.$refs.wxopentag.register()
    }
  }
};
</script>

<style lang="css" scoped>
header {
    height: 13.4rem;
    background: url('~@/assets/image/activitySigned/bg_ic@2x.png') no-repeat;
    background-size: cover;
}
.banner img {
  width: 100%;
  height: 16.5rem;
  object-fit: cover;
  z-index: 1;
}

.content {
    position: relative;
    border-radius: 1.5rem 1.5rem 0 0;
    margin-top: -1.5rem;
    z-index: 2;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 54px 64px;
}

.succeedImg {
  width: 67px;
}

.txt1 {
  margin-top: 8px;
  line-height: 37.5px;
  font-size: 19px;
  font-weight: 700;
  color: #1d2023;
}

.txt2 {
  margin-top: 13px;
  font-size: 42.5px;
  font-weight: 700;
  color: #F01B26;
}
.txt3 {
  margin-top: 13.5px;
  line-height: 42.5px;
  font-size: 18.5px;
  font-weight: 700;
  color: #333333;
}
.txt4 {
  margin-top: 106px;
  line-height: 22.5px;
  font-size: 15px;
  font-weight: 400;
  color: #555555;
}

.openApp {
    margin-top: 10px;
    position: relative;
    width: 100%;
    height: 4.5rem;
    line-height: 4.5rem;
    text-align: center;
    border-radius: 4.5rem;
    background-color: #F7443F;
    font-size: 1.6rem;
    color: #FFF;
  }
</style>
